import { Input, InputGroup, InputLeftElement } from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import { useTranslation } from "react-i18next";

type Props = {
  value: string;
  onChange: (next: string) => void;
  isDisabled?: boolean;
  isInvalid?: boolean;
};

export const CpvSearchInput = ({ value, onChange, isDisabled, isInvalid }: Props) => {
  const { t } = useTranslation();
  return (
    <InputGroup>
      <InputLeftElement pointerEvents="none">
        <SearchIcon color="smMuted" />
      </InputLeftElement>
      <Input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        isDisabled={isDisabled}
        isInvalid={isInvalid}
        placeholder={
          t("Search for CPV code or category, e.g. 'IT services' or '72000000'") ??
          undefined
        }
        onKeyDown={(e) => {
          if (e.key === "Escape") onChange("");
        }}
      />
    </InputGroup>
  );
};
